import { render } from "./TopbarElement.vue?vue&type=template&id=d9d79054&scoped=true"
import script from "./TopbarElement.vue?vue&type=script&lang=js"
export * from "./TopbarElement.vue?vue&type=script&lang=js"

import "./TopbarElement.vue?vue&type=style&index=0&id=d9d79054&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9d79054"]])

export default __exports__